import { render, staticRenderFns } from "./pricing-strategy-modal.vue?vue&type=template&id=3c2d08a1&"
import script from "./pricing-strategy-modal.vue?vue&type=script&lang=js&"
export * from "./pricing-strategy-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports